import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { ScrollableList, Text, Box, ScrollableListVariant, ScrollDirection } from '@as/cotopaxi';
import { QuickFilterItem } from './QuickFilterItem';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import { useSelector } from 'react-redux';
import { makeGetQuickLinks } from '../../../redux/lister/selectors/ListerSelector';
export const QuickFilters = () => {
    const { t } = useTranslation(I18N_NAMESPACES.product);
    const quickLinks = useSelector(makeGetQuickLinks());
    if (!(quickLinks && quickLinks.length > 0)) {
        return null;
    }
    return (_jsxs(_Fragment, { children: [_jsx(Text, { inline: true, emphasized: true, children: t('product.lister.quickFilters.title') }), _jsx(Box, { mobile: { spacing: { marginTop: 2 } }, children: _jsx(ScrollableList, { direction: ScrollDirection.HORIZONTAL, variant: ScrollableListVariant.GRADIENT, touchOnly: true, dataAnalyticsBannerid: "product-lister-quicklinks", children: quickLinks.map(quickLink => (_jsx(QuickFilterItem, { quickLink: quickLink }, `quickLink_${quickLink.linkName}`))) }) })] }));
};
